export default "__VITE_ASSET__8c84e956__"